"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  dangerouslySetInnerHTML: {
    __html: "<path d=\"M4.416 10.205C1.878 13.5 2.384 20.462 8.988 22c0 0-3.556-5.128 1.016-8.718-.508 5.128 3.555 9.167 6.095 8.205C20 20.01 24.5 14 17.115 6.103 18.131 10.205 15 12 15 12s1.1-6.923-3.98-10C10 7.5 6.954 6.91 4.416 10.205z\" fill=\"#000\"></path>"
  },
  viewBox: "0 0 24 24",
  fill: "none"
};
exports["default"] = _default;